module.exports = __webpack_public_path__ + "static/media/bungalow2.ed88787d.jpg";